const FileUpload = ({
  name,
  title,
  file,
  onChange,
  onRemove,
  required = false,
  error,
  accept = ".pdf,.jpg,.jpeg,.png",
  maxSizeMB = 5,
  fileTypesText = "PDF, JPG or PNG",
}) => {
  return (
    <div className="upload-box">
      <div className="upload-icon">↑</div>

      <div className="upload-content">
        <h3>
          {title}
          {required && <span> *</span>}
        </h3>

        <p>{file ? file.name : `${fileTypesText} · Max ${maxSizeMB} MB`}</p>

        {error && <small className="error-message">{error}</small>}
      </div>

      <div className="file-actions">
        <label className="file-button">
          {file ? "Change" : "Choose File"}

          <input
            type="file"
            name={name}
            onChange={onChange}
            required={required && !file}
            accept={accept}
          />
        </label>

        {file && (
          <button
            type="button"
            className="remove-button"
            onClick={() => onRemove(name)}
            aria-label={`Remove ${title}`}
          >
            Remove
          </button>
        )}
      </div>
    </div>
  );
};

export default FileUpload;
